import React, { Component } from "react";
import { Row, Col, Steps, Popover } from "antd";
import { connect } from "react-redux";
import { AuthAction, UserAction } from "../../store/actions";
import Register from "./register";
import Profile from "./profile";
import Personalize from "./personalize";
import AddPlant from "./Addplant";
import Subscription from "./Subcription";
import { AiOutlineTwitter, FaFacebookF, FaInstagram } from "react-icons/all";
import RmxFooterImage from "../../assets/images/footerIcon.png";
import RmxFooter from "../../assets/images/footer.png";
class SignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 0,
      userInfo: {},
    };
  }
  userData = (data) => {
    this.setState({
      userInfo: data,
    });
  };

  checkLocation = (details) => {
    if (!details.logistics_partner_locations.length) {
      this.setState({
        count: 2,
      });
      return;
    }
    if (!details?.logistics_partner_asset) {
      this.setState({
        count: 3,
      });
      return;
    }
    if (!details?.subscription_status) {
      this.setState({
        count: 4,
      });
      return;
    }
  };
  render() {
    const { count } = this.state;
    console.log("USER==>", this.props.companyDetails);
    return (
      <Row>
        <Col span={24}>
          {count === 0 && (
            <Register
              count={count}
              onChangeStep={() =>
                this.setState({
                  count: this.state.count + 1,
                })
              }
              userData={this.userData}
              checkLocation={this.checkLocation}
              {...this.props}
            />
          )}

          {count === 1 && (
            <Profile
              count={count}
              onChangeStep={() =>
                this.setState({
                  count: this.state.count + 1,
                })
              }
              user={this.state.userInfo}
            />
          )}
          {count === 2 && (
            <AddPlant
              count={count}
              onChangeStep={() =>
                this.setState({
                  count: this.state.count + 1,
                })
              }
            />
          )}
          {count === 3 && (
            <Personalize
              count={count}
              onChangeStep={() =>
                this.setState({
                  count: this.state.count + 1,
                })
              }
            />
          )}

          {count === 4 && (
            <Subscription
              count={count}
              onChangeStep={() =>
                this.setState({
                  count: this.state.count + 1,
                })
              }
              {...this.props}
            />
          )}
        </Col>
        <Col span={24}>
          <Row>
            <Col
              xl={24}
              className="rmx-containers"
              style={{
                fontWeight: "500",
                backgroundImage: `url(${RmxFooter})`,
              }}
            >
              <Row
                className="rmx-footer-row"
                justify="space-between"
                align="middle"
              >
                <Col xl={6}>
                  <img
                    src={RmxFooterImage}
                    className="rmx-footer-image"
                    height={250}
                    width={250}
                  />
                </Col>
                <Col xl={8}>
                  <Row>
                    <Col span={24}>
                      <h3 style={{ fontWeight: "750" }}>MAIN-FRAME</h3>
                    </Col>
                    <Col span={24}>
                      <span>
                        888 Prospect Street, Suite 200, La Jolla, CA 92037
                      </span>
                    </Col>
                    <Col span={24}>
                      <span>info@main-frame.com </span>
                    </Col>
                    <Col span={24}>
                      <span>+1 619 880 0265</span>
                    </Col>
                  </Row>
                </Col>

                <Col xl={6} style={{ paddingBottom: "50px" }}>
                  {/* <Row
                    justify="start"
                    align="bottom"
                    className="rmx-footer-icons"
                  >
                    <Col xl={4} className="pointer-cursor">
                      <AiOutlineTwitter color="black" size="25" />
                    </Col>
                    <Col xl={4} className="pointer-cursor">
                      <FaFacebookF color="black" size="25" />
                    </Col>
                    <Col xl={4} className="pointer-cursor">
                      <FaInstagram color="black" size="25" />
                    </Col>
                  </Row> */}
                </Col>
              </Row>
              <Col
                className="rmx-copyright"
                style={{ color: "black", fontWeight: "600" }}
              >
                <span>
                  © {new Date().getFullYear()} Main Frame . All Rights Reserved.
                </span>
              </Col>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

function mapStateToProps(storeState) {
  return {
    loader: storeState?.AuthReducer.loader,
    companyDetails: storeState?.UserReducer?.companyDetails,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    signup: (payload, cb) => dispatch(AuthAction.SignUp(payload, cb)),
    getCompanyDetails: (id, cb) =>
      dispatch(UserAction.getCompantDetailReq(id, cb)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);
